var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonComponent',{staticClass:"image-create-trigger",attrs:{"type":"button"}},[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('Icon',{staticClass:"ml-1",attrs:{"icon":['fas', 'image']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }